module.exports = __webpack_public_path__ + "img/icon-calendar-event-active.23718388.svg";